export default __webpack_public_path__ + "static/media/cx_cover_fsc56.f8e7afd6.jpeg";